import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About Us" },
    { to: "/services", label: "Services" },
    { to: "/contact", label: "Contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav data-testid="navbar" className="glass-nav fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
            <img
              src="https://vaanabuildlogictechnologies.com/logo.png"
              alt="Vaana BuildLogic Technologies"
              className="h-10 w-auto"
            />
            <span className="hidden sm:block text-white font-semibold text-lg font-['Outfit']">
              
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                className={`text-sm font-medium transition-colors duration-300 ${
                  isActive(link.to)
                    ? "text-[#00E5FF]"
                    : "text-[#94A3B8] hover:text-white"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              data-testid="nav-cta-button"
              className="px-5 py-2 bg-[#00E5FF] text-[#060B19] text-sm font-semibold rounded-sm hover:bg-[#33EEFF] transition-all duration-300 btn-glow"
            >
              Get Started
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div data-testid="mobile-menu" className="md:hidden pb-6 border-t border-white/10 mt-2 pt-4">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`block py-3 text-sm font-medium ${
                  isActive(link.to) ? "text-[#00E5FF]" : "text-[#94A3B8]"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="mt-3 inline-block px-5 py-2 bg-[#00E5FF] text-[#060B19] text-sm font-semibold rounded-sm"
            >
              Get Started
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
